import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function getSampleList 获取抽检列表
 * @returns {Object} ids 分组 id mark 标记
 */
const getSampleList = (query) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/sample?per=10&${query}`
    )
    .then(checkResponse)
}

/**
 * @function deleteSample 删除抽检
 * @returns {Object} ids 分组 id mark 标记
 */
const deleteSample = (id) => {
  return axios
    .delete(
      `/api/v1/projects/${getProjectId()}/screen/sample/${id}`
    )
    .then(checkResponse)
}

/**
 * @function getSampleDetail 获取抽检详情
 * @returns {Object} ids 分组 id mark 标记
 */
const getSampleDetail = (id) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/sample/${id}`
    )
    .then(checkResponse)
}

/**
 * @function getRoadList 获取道路详情
 * @returns {Object} ids 分组 id mark 标记
 */
const getRoadList = (id,query) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/sample/${id}/road?per=10&${query}`
    )
    .then(checkResponse)
}

/**
 * @function setRoadRemarks 设置道路备注
 * @returns {Object} ids 分组 id mark 标记
 */
const setRoadRemarks = (sampleId,roadId, query) => {
  return axios
    .put(
      `/api/v1/projects/${getProjectId()}/screen/sample/${sampleId}/road/${roadId}`,query
    )
    .then(checkResponse)
}

/**
 * @function deleteSample 删除抽检道路
 * @returns {Object} ids 分组 id mark 标记
 */
const deleteRoad = (sampleId,roadId) => {
  return axios
    .delete(
      `/api/v1/projects/${getProjectId()}/screen/sample/${sampleId}/road/${roadId}`
    )
    .then(checkResponse)
}

/**
 * @function getRoadDetail 获取道路详情列表
 * @returns {Object} ids 分组 id mark 标记
 */
const getRoadDetail = (sampleId,roadId) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/sample/${sampleId}/road/${roadId}/list`
    )
    .then(checkResponse)
}

/**
 * @function postSample 新建抽检第一步
 * @returns {Object} ids 分组 id mark 标记
 */
const postSample = (query) => {
  return axios
    .post(
      `/api/v1/projects/${getProjectId()}/screen/sample`,query
    )
    .then(checkResponse)
}

/**
 * @function getSampleNum 新建抽检第二布
 * @returns {Object} ids 分组 id mark 标记
 */
const getSampleNum= (sampleId,group) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/sample/${sampleId}/problem?groupSample=${group}`
    )
    .then(checkResponse)
}

/**
 * @function getRoadDetailMap 获取道路详情地图
 * @returns {Object} ids 分组 id mark 标记
 */
const getRoadDetailMap= (sampleId,roadId) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/sample/${sampleId}/road/${roadId}/map`
    )
    .then(checkResponse)
}


/**
 * @function getRoadMap 获取道路地图
 * @returns {Object} ids 分组 id mark 标记
 */
const getRoadMap= (sampleId) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/sample/${sampleId}/road/map`
    )
    .then(checkResponse)
}


/**
 * @function getDownloadSample 下载抽检
 * @returns {Object} ids 分组 id mark 标记
 */
const getDownloadSample= (sampleId) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/screen/sample/${sampleId}/road/download`
    )
    .then(checkResponse)
}

export{
  getSampleList,
  deleteSample,
  getSampleDetail,
  getRoadDetail,
  setRoadRemarks,
  deleteRoad,
  getRoadList,
  postSample,
  getSampleNum,
  getRoadDetailMap,
  getRoadMap,
  getDownloadSample
}
